import React from "react";

import { sendTestEmail } from "@admin/api/config";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const usePostEmailConfig = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const onMutate = () => {
        setIsLoading(true);
        void sendTestEmail()
            .then(() => showSuccessToast("Test email sent successfully"))
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err.message);
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
